import { API_PREFIX } from './constant'
import { Request } from './request'

export interface PatientDataParams {
  current?: any
  size?: any
  state?: any
  timeHead?: any
  timeTail?: any
  startTime?: any
  endTime?: any
  param?: any
  registrationId?: any
  useMethod?: any
  settlementStatus?: any
  showRefund?: any
}

export function PatientDataList(params: PatientDataParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/blade-outpatient/recipeexecute/list`,
    method: 'GET',
    params,
  }
}

// 获取右侧处方
export function MedicalRecipeDetail(params: PatientDataParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeexecute/getRecipeExecuteByRegistrationId`,
    method: 'GET',
    params,
  }
}

// 查询单个多个执行详情
export interface ExecutionDetailParams {
  recipeId?: any
  recipeItemId?: any
}
export function ExecutionDetail(params: ExecutionDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeexecute/detailsByRecipeId`,
    method: 'GET',
    params,
  }
}

// 执行记录
export interface ExcuteTableListParams {
  workstationId?: any
}

export function ExcuteTableList(params: ExcuteTableListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeexecute/getExecuteRecordList`,
    method: 'GET',
    params,
  }
}

export interface ExecuteSubmitParams {
  attachmentFile?: any
  executeNum?: any
  executeTime?: any
  id?: any
  operatorName?: any
  operatorId?: any
  remark?: any
  recipeId?: any
  recipeItemId?: any
  workstationId?: any
}
export function ExecuteSubmit(body: ExecuteSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeexecute/batchExecute`,
    method: 'POST',
    body,
  }
}



